import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PAGE_NOT_FOUND, routes } from './routes';

const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!routes.includes(pathname)) {
            navigate(PAGE_NOT_FOUND);
        }
    }, [pathname]);

    return null;
};

export default DefaultRedirect;
